export const SCOUTING_TAGS = [
  'rub',
  'scrape',
  'trail_cam',
  'food_plot',
  'shed',
  'track',
  'sighting',
  'stand_check',
  'access_route',
  'sign',
  'other',
] as const;

export type ScoutingTag = (typeof SCOUTING_TAGS)[number];

export interface LogEntry {
  id: string;
  waypointId: string;
  propertyId?: string; // Required in M12 rework
  date: string; // ISO 8601 date
  time?: string; // ISO 8601 time — required in M12 rework
  notes: string;
  tags: string[];

  // Environmental Context — auto-populated in Phase 2
  weatherTemp?: number;
  weatherCondition?: string;
  weatherPrecipitation?: string;
  windDirection?: string;
  windSpeed?: number;
  moonPhase?: string;
  moonIllumination?: number;
  barometricPressure?: number;
  barometricTrend?: 'rising' | 'falling' | 'steady';

  // Additional weather fields — Phase 2 (M19+M21)
  weatherFeelsLike?: number;
  weatherHumidity?: number;
  weatherIcon?: string;          // OWM icon code e.g., "03d"

  // Sun times — Phase 2 (M20)
  sunriseTime?: string;       // ISO time string
  sunsetTime?: string;        // ISO time string
  civilDawnTime?: string;     // ISO time string — first legal shooting light
  civilDuskTime?: string;     // ISO time string — last legal shooting light

  // Animal Observation — optional
  animalObserved?: boolean;
  animalSpecies?: string;
  animalSex?: 'buck' | 'doe' | 'fawn' | 'unknown';
  animalAgeClass?: string;
  animalAntlerDescription?: string;
  animalCount?: number;
  animalBehavior?: string;

  // Media — Phase 2
  photos?: string[];

  // Conditions Quality — Phase 4 (M38). Null for entries created offline or before M38.
  conditionsQuality?: import('@/types/conditions').LogEntryConditionsQuality | null;

  createdAt: string;
  updatedAt: string;
}

export type CreateLogEntryInput = Omit<LogEntry, 'id' | 'createdAt' | 'updatedAt'>;
export type UpdateLogEntryInput = Partial<CreateLogEntryInput>;

// Reusable animal observation record (used in HuntSit.observations)
export interface AnimalObservation {
  species?: string;
  sex?: 'buck' | 'doe' | 'fawn' | 'unknown';
  ageClass?: string;
  antlerDescription?: string;
  count?: number;
  behavior?: string;
}
